<template>
  <PlotBasePanel :settings="settings">
    <div class="controls">
      <SignalsCombobox v-model="signalBox" :values="signalBox_Values" :title="'Сигнал:'" :width="90" />
      <ScaleCombobox v-model="scaleX" :values="scaleX_Values" :title="'Скорость:'" :width="60" class="ml-5" :unit="scaleX_Unit" />
      <ScaleCombobox v-model="scaleY" :values="scaleY_Values" :title="'Масштаб:'" :width="90" class="ml-5" :unit="scaleY_Unit" />
      <FiltersCombobox v-model="filters" :values="filters_Values" :title="'Фильтры:'" :width="160" class="ml-5" />
    </div>
  </PlotBasePanel>
</template>

<script>
import ScaleCombobox from "../core/scale-combobox";
import FiltersCombobox from "../core/filters-combobox";
import SignalsCombobox from "../core/signals-combobox";
import PlotBasePanel from "../core/plot-base-panel";

export default {
  name: "OnlineRhythmPlot",
  emits: ["signalsChanged", "scaleXChanged", "scaleYChanged", "filtersChanged"],

  components: {
    ScaleCombobox,
    FiltersCombobox,
    SignalsCombobox,
    PlotBasePanel
  },

  props: {
    settings: Object
  },

  data: () => ({
    // Toolbar values
    scaleX: null,
    scaleY: null,
    filters: null,
    signalBox: null,
    controlsPrepared: true // Для отмены создания событий во время инициализации значений тулбара (масштабы фильтры и т.д.)
  }),
  computed: {
    scaleX_Values() {
      return this.settings.scaleX.values;
    },
    scaleY_Values() {
      return this.settings.scaleY.values;
    },
    scaleX_Unit() {
      return this.settings.scaleX.unit;
    },
    scaleY_Unit() {
      return this.settings.scaleY.unit;
    },
    filters_Values() {
      return this.settings.filters.allowed;
    },
    signalBox_Values() {
      return this.settings.signalBox.values;
    }
  },

  watch: {
    scaleX(val) {
      !this.isEqual(this.settings.scaleX.current, val) && this.$emit("scaleXChanged", val);
    },
    scaleY(val) {
      !this.isEqual(this.settings.scaleY.current, val) && this.$emit("scaleYChanged", val);
    },
    filters(val) {
      !this.isEqual(this.settings.filters.current, val) && this.$emit("filtersChanged", val);
    },
    signalBox(val) {
      !this.isEqual(this.settings.signalBox.current, val) && this.$emit("signalsChanged", val);
    },
    settings() {
      this.extractToolbarSettings();
    }
  },
  methods: {
    extractToolbarSettings() {
      this.controlsPrepared = false;
      const { scaleX, scaleY, filters, signalBox } = this.settings;
      this.scaleX = scaleX.current;
      this.scaleY = scaleY.current;
      this.filters = filters.current;
      this.signalBox = signalBox.current;
      this.controlsPrepared = true;
    },

    isEqual(obj1, obj2) {
      return obj1 === obj2 || JSON.stringify(obj1) === JSON.stringify(obj2);
    }
  },
  mounted() {
    this.extractToolbarSettings();
  }
};
</script>
